import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment'

@Pipe({ name: 'humanDate' })
export class HumanDatePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  transform(date) {
    return moment.duration(moment(date).diff(moment())).locale(this.translate.currentLang).humanize(true)
  }
}



// WEBPACK FOOTER //
// ./src/app/core/pipes/humanDate.pipe.ts